import type { AchievementFragment } from '@lingoda/monolith-graphql';

export const getAchieved = ({ currentProgress, value }: AchievementFragment) =>
    currentProgress >= value;
